/**
 * Constants for WADM-compatible queryFilter shapes used by
 * SearchEWasteContainers / SearchEWasteItems.
 */

export const FILTER_TYPE = Object.freeze({
    MUST: "MUST",
    SHOULD: "SHOULD",
    MUST_NOT: "MUST_NOT"
});

export const QUERY_TYPE = Object.freeze({
    MATCH: "MATCH",
    GREATER_THAN_EQUAL: "GREATER_THAN_EQUAL",
    LESS_THAN_EQUAL: "LESS_THAN_EQUAL"
});

export const SORT_DIRECTION = Object.freeze({
    ASC: "ASC",
    DESC: "DESC"
});

export const QUERY_FIELD = Object.freeze({
    STATUS: "status",
    CREATED_AT: "createdAt",
    CONTAINER_ID: "containerId",
    // Item search fields (WADM item index) used by the WTN dashboard filters.
    EWC_CODE: "ewcCode",
    WTN_DOCUMENT_ID: "wtnDocumentId",
    ITEM_NAME: "itemName",
    ORDER_NUMBER: "orderNumber"
});



// WEBPACK FOOTER //
// ./src/commons/constants/WadmQueryFilter.js